import { gql } from '@apollo/client'

export const UPDATE_STORE = gql`
  mutation updateStoreHasura($store_id: uuid!, $accounts_email: String) {
    update_stores(
      where: { id: { _eq: $store_id } }
      _set: { accounts_email: $accounts_email }
    ) {
      affected_rows
      returning {
        id
      }
    }
  }
`
